import { useState } from "react";

export type SortField = "ACT_DATE";
export type SortDirection = "ASC" | "DESC";

export function useSortState() {
  const [sortField, setSortField] = useState<SortField>("ACT_DATE");
  const [sortDirection, setSortDirection] = useState<SortDirection>("DESC");

  const onSort = (field: SortField, direction: SortDirection) => {
    setSortField(field);
    setSortDirection(direction);
  };

  return { sortField, sortDirection, onSort };
}

export type SortState = ReturnType<typeof useSortState>;
